import {
  BibliographySetDetailAuthority,
  BibliographySetDetailAuthorityFromJSON,
  BibliographySetDetailAutoOrder,
  BibliographySetDetailAutoOrderFromJSON,
  BibliographySetDetailBibliography,
  BibliographySetDetailBibliographyFromJSON,
  BibliographySetDetailDetail,
  BibliographySetDetailDetailFromJSON,
  BibliographySetDetailMarc,
  BibliographySetDetailMarcFromJSON,
  BibliographySetDetailVolume,
  BibliographySetDetailVolumeFromJSON,
  BibliographySetManagementInfo,
  BibliographySetManagementInfoFromJSON,
  defaultBibliographySetDetailBibliography,
  defaultBibliographySetManagementInfo,
  exists
} from '@/api'

export interface BibliographySetDetail {
  bibliography: BibliographySetDetailBibliography
  volumes: BibliographySetDetailVolume[]
  details: BibliographySetDetailDetail[]
  authorities: BibliographySetDetailAuthority[]
  autoOrders: BibliographySetDetailAutoOrder[]
  marcs: BibliographySetDetailMarc[]
  managementInfo: BibliographySetManagementInfo
}

export const defaultBibliographySetDetail = (): BibliographySetDetail => ({
  bibliography: defaultBibliographySetDetailBibliography(),
  volumes: [],
  details: [],
  authorities: [],
  autoOrders: [],
  marcs: [],
  managementInfo: defaultBibliographySetManagementInfo()
})

export function BibliographySetDetailFromJSON(
  json: any
): BibliographySetDetail {
  return {
    bibliography: exists(json, 'bibliography')
      ? BibliographySetDetailBibliographyFromJSON(json.bibliography)
      : defaultBibliographySetDetailBibliography(),
    volumes: exists(json, 'volumes')
      ? json.volumes.map(BibliographySetDetailVolumeFromJSON)
      : [],
    details: exists(json, 'bibliography_details')
      ? json.bibliography_details.map(BibliographySetDetailDetailFromJSON)
      : [],
    authorities: exists(json, 'bibliography_details')
      ? json.bibliography_authorities.map(
          BibliographySetDetailAuthorityFromJSON
        )
      : [],
    autoOrders: exists(json, 'auto_orders')
      ? json.auto_orders.map(BibliographySetDetailAutoOrderFromJSON)
      : [],
    marcs: exists(json, 'marcs')
      ? json.marcs.map(BibliographySetDetailMarcFromJSON)
      : [],
    managementInfo: exists(json, 'management_info')
      ? BibliographySetManagementInfoFromJSON(json.management_info)
      : defaultBibliographySetManagementInfo()
  }
}
